import { useEffect } from "react";
import redClockImg from "../../assets/short_recording.svg";
import AssessmentNotConductedImg from "../../assets/result_not_available_girl.svg";
import keyboardBackBtn from "../../assets/keyboard_back_btn.svg";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./styles.css";
import useParamValues from "../../utils/useParamValues";
import { getUserProperties } from "../../utils/helper";
import { produceEventLog } from "../../utils/helper";
import { UrlConstants } from "../../utils/CommonUtils/constants";

const AssessmentNotConductedScreen = ({ handleShowStudentList }) => {
  const { t } = useTranslationSetup();
  const userProperties = getUserProperties(useParamValues());
  const showComparison = UrlConstants.SHOW_COMPARISON;
  useEffect(() => {
    produceEventLog("assessment_3_no_result_available_page", {
      ...userProperties,
    });
  }, []);
  return (
    <div className="assessment-not-conducted-container">
      <div>
        <img
          src={showComparison ? AssessmentNotConductedImg : redClockImg}
          alt="Missing Assessment"
          className="center-image"
        />
        <div className="assessment-not-conducted-heading">
          {showComparison ? t("result_not_available") : t("student_not_assessed")}
        </div>
        <div className="assessment-not-conducted-description">
          {showComparison
            ? t("result_not_available_description")
            : t("student_not_assessed_description")}
        </div>
      </div>
      {/* <div className="assessment-not-conducted-close-screen-message">
        {t("close_screen_message")}
      </div> */}
      {/* <div
        className="assessment-not-conducted-back-btn"
        onClick={handleShowStudentList}
      >
        <img src={keyboardBackBtn} alt="back button" />
        {t("student_list")}
      </div> */}
    </div>
  );
};

export default AssessmentNotConductedScreen;
